import { FC } from "react";
import { Form } from "antd";
import { BaseFilter } from "src/constants";
import { TIME_SEGMENTS } from "./constants";

const ButtonGroup: FC<{
  value?: [number, number];
  onChange?: (value?: [number | undefined, number | undefined]) => void;
}> = ({
  value,
  onChange,
}) => {
  const handleClick = (offsetFrom: number, offsetTo: number) => {
    if (value && value[0] === offsetFrom && value[1] === offsetTo) {
      onChange?.(undefined);
      return;
    }
    onChange?.([offsetFrom, offsetTo]);
  };

  return (
    <div className="grid grid-cols-2 grid-rows-2 gap-2">
      {TIME_SEGMENTS.map((button) => {
        const from = button.offsetFrom;
        const to = button.offsetTo;
        const isSelected = value && value[0] === from && value[1] === to;

        return (
          <div
            key={button.title}
            onClick={() => handleClick(from, to)}
            className={` hover:border-border-active hover:text-font-active font-inter flex cursor-pointer select-none flex-col items-center justify-center gap-1 whitespace-nowrap rounded-md border p-3 transition-all
            ${isSelected ? "border-border-active text-font-active" : "bg-background-default border-border-hover text-font-default"}`}
          >
            <div>{button.icon}</div>
            <div className="text-14">{button.title}</div>
            <div className="text-12 text-font-subtle">{button.subTitle}</div>
          </div>
        );
      })}
    </div>
  );
};

const TimeSegments: FC<{ filter: BaseFilter }> = ({ filter }) => {
  return (
    <Form.Item name={filter.key} className="m-0!">
      <ButtonGroup />
    </Form.Item>
  );
};

export default TimeSegments;
